export default __webpack_public_path__ + "static/henderson-international-8d5f13830ebc2097676d559fd075d0f6.png";